export default "__VITE_ASSET__Uu9p5Wkl__"